<template>
  <jz-container
    :class="[
      'picture-match-option',
      { selected: selected, correct: correct, incorrect: incorrect },
      this.$data.staticClass
    ]"
    v-bind="this.$attrs"
    @click="$listeners['click']"
  >
    <jz-container class="header">
      <jz-container class="title">{{ header[0] }}</jz-container>
      <jz-icon class="selection-icon" v-if="selectionIcon" :src="selectionIcon" />
      <jz-icon class="correct-icon" v-if="correct || incorrect" :src="correctIcon" />
    </jz-container>
    <jz-container class="image">
      <img :src="image" />
    </jz-container>
  </jz-container>
</template>

<script>
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconSelected from "@joyz/app-core/assets/icons/misc/TT4WRadioChecked.svg";
import IconUnselected from "@joyz/app-core/assets/icons/misc/TT4WRadio.svg";

export default {
  name: "PictureMatchOption",
  props: {
    correct: {
      type: Boolean,
      default: false
    },
    header: {
      type: Array,
      default: () => [""]
    },
    image: {
      type: String,
      default: ""
    },
    incorrect: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      icons: {
        correct: IconCorrect,
        incorrect: IconIncorrect,
        selected: IconSelected,
        unselected: IconUnselected
      }
    };
  },
  computed: {
    correctIcon() {
      if (this.correct) {
        return this.icons.correct;
      } else if (this.incorrect) {
        return this.icons.incorrect;
      }

      return null;
    },
    selected() {
      return this.status === "selected";
    },
    selectionIcon() {
      return this.icons[this.status];
    }
  }
};
</script>

<style lang="scss">
.picture-match-option {
  border: 1px solid #d7dadb;
  overflow: hidden;

  &.selectable {
    cursor: pointer;
  }

  &.selected {
    border: 1px solid var(--color-secondary);
  }

  &.correct {
    .header {
      background-color: var(--color-success-background-light);
    }
  }

  &.incorrect {
    .header {
      background-color: var(--color-danger-background-light);
    }
  }

  &:nth-child(1) {
    border-top-left-radius: 12px;

    .header {
      border-top-left-radius: 12px;
    }
  }

  &:nth-child(2) {
    border-top-right-radius: 12px;

    .header {
      border-top-right-radius: 12px;
    }
  }

  &:nth-child(3) {
    border-bottom-left-radius: 12px;
  }

  &:nth-child(4) {
    border-bottom-right-radius: 12px;
  }

  .header {
    background-color: var(--color-secondary-background-light);
    display: flex;
    justify-content: space-between;
    padding: ($gutter / 2) ($gutter / 2) ($gutter / 2) $gutter;
    position: relative;

    .selection-icon {
      background-color: #fff;
      border-radius: 50%;
      height: $icon-size-base;
      width: $icon-size-base;
    }

    .correct-icon {
      position: absolute;
      left: calc(50% - (#{$icon-size-lg} / 2));
      height: $icon-size-lg;
      top: 4.5px;
      width: $icon-size-lg;
    }
  }

  .image {
    text-align: center;

    img {
      display: block;
      height: auto;
      margin: 0 auto;
      max-width: 100%;
    }
  }
}
</style>
